import styled from "styled-components";

export const StyledParagraph = styled("p")`
    font-size: 15px;
    margin: 12px 0 0;
    line-height: 24px;
`